/* unplugin-vue-components disabled */import { render } from "./RealNameGuide.vue?vue&type=template&id=7eb24fe6&scoped=true"
import script from "./RealNameGuide.vue?vue&type=script&lang=js"
export * from "./RealNameGuide.vue?vue&type=script&lang=js"

import "./RealNameGuide.vue?vue&type=style&index=0&id=7eb24fe6&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb24fe6"]])

export default __exports__